import React from 'react';
import { Clock, CheckCircle, User } from 'lucide-react';
import { PromptTemplateVersion } from '../../../types/prompt';

interface TemplateVersionHistoryProps {
  versions: PromptTemplateVersion[];
  onSelectVersion: (version: PromptTemplateVersion) => void;
  currentVersionId?: number;
}

export default function TemplateVersionHistory({
  versions,
  onSelectVersion,
  currentVersionId
}: TemplateVersionHistoryProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">
        Version History
      </h4>
      
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {versions.map((version) => (
          <button
            key={version.id}
            onClick={() => onSelectVersion(version)}
            className={`
              w-full text-left p-3 rounded-lg border transition-colors
              ${currentVersionId === version.id
                ? 'border-blue-500 bg-blue-100'
                : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
              }
            `}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-medium text-gray-900 dark:text-white">
                    v{version.version}
                  </span>
                  {version.isActive && (
                    <span className="px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded">
                      Active
                    </span>
                  )}
                </div>
                
                {version.changeNotes && (
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    {version.changeNotes}
                  </p>
                )}
                
                <div className="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-500">
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {new Date(version.createdAt).toLocaleDateString()}
                  </span>
                  {version.createdBy && (
                    <span className="flex items-center gap-1">
                      <User className="w-3 h-3" />
                      {version.createdBy}
                    </span>
                  )}
                </div>
              </div>
              
              {version.isActive && (
                <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 mt-1 ml-2" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}